import { render, staticRenderFns } from "./AddEditCertificate.vue?vue&type=template&id=6fdbd87a"
import script from "./AddEditCertificate.vue?vue&type=script&lang=js"
export * from "./AddEditCertificate.vue?vue&type=script&lang=js"
import style0 from "./AddEditCertificate.vue?vue&type=style&index=0&id=6fdbd87a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports